import { Controller } from "@hotwired/stimulus"

// Confirmation belongs to the current channel and recipient, not the form.
export default class extends Controller {
  static targets = ["confirmation", "eventId"]

  recipientChanged(event) {
    if (["delivery_channel", "recipient"].includes(event.target.name)) {
      this.confirmationTarget.checked = false
      this.eventIdTarget.value = crypto.randomUUID()
    }
  }
}
